import React from 'react';
import { motion } from 'framer-motion';

const WelcomeHereSection = () => {
    const fadeUpVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    return (
        <section className="w-full py-[40px] md:py-[100px] bg-white font-sora">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    variants={fadeUpVariant}
                    className="relative flex flex-col md:flex-row items-center justify-center min-h-0 md:min-h-[500px]"
                >
                    <div className="w-full md:w-3/5 h-[240px] sm:h-[300px] md:h-full md:absolute md:left-0 md:top-0 overflow-hidden shadow-sm rounded-sm shrink-0">
                        <img
                            src="/assets/work/img3.png"
                            alt="Abstract blue swirl background"
                            className="w-full h-full object-cover transition-transform duration-700 ease-in-out md:hover:scale-105"
                        />
                    </div>
                    <div className="w-[95%] sm:w-[90%] md:w-1/2 bg-white border border-[#01386A45] p-[20px] sm:p-[30px] md:p-[60px] lg:p-[80px] shadow-[0_4px_20px_rgba(0,0,0,0.04)] relative z-10 md:ml-auto md:mr-[5%] -mt-[40px] sm:view--mt-[50px] md:mt-0 transition-transform duration-300 md:hover:-translate-y-1 md:hover:shadow-[0_12px_40px_rgba(0,0,0,0.08)] rounded-sm">
                        <h2 className="text-[20px] lg:text-[30px] font-[600] text-[#01386A] tracking-tight mb-[12px] md:mb-[24px]">
                            You're welcome here
                        </h2>
                        <p className="text-[#49577A] text-[14px] md:text-[16px] font-graphik font-[500] leading-[1.6] md:leading-[1.7]">
                            We believe great ideas come from different voices and experiences. That’s why we welcome people from all backgrounds and perspectives. When we come together, we learn from each other, think differently, and create better solutions. We’re building a workplace where everyone feels included, valued, and able to do their best work.
                        </p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default WelcomeHereSection;